import { Component, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ListResult } from '../../../api/core/list-result';
import { Audience } from '../../../api/enum';
import { KeywordLookupItem } from '../../../api/lookup/keyword-lookup-item';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';

export interface KeywordPickerEvent {
  keywords: KeywordLookupItem[];
}

@Component({
  selector: 'app-keyword-picker',
  standalone: true,
  imports: [FormsModule, AutoCompleteModule],
  templateUrl: './keyword-picker.component.html',
  styles: [
    `.keyword-key {
      list-style: 1.5em;
      margin-bottom: 0.25em;
    }
    .keyword-title {
      font-size: 0.9286em;
      color: #999999;
    }`
  ],
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KeywordPickerComponent),
      multi: true,
    },
  ],
})
export class KeywordPickerComponent extends BasePickerComponent<KeywordLookupItem> {
  @Input() writableOnly: boolean = false;
  @Input() lookupOnly: boolean = false;
  @Input() linkableOnly: boolean = false;
  @Input() includeDetails: boolean = false;
  @Input() audience: Audience = Audience.Internal;
  @Input() formId: string = '';
  @Output() KeywordsLoaded = new EventEmitter<KeywordPickerEvent>();
  @Output() keywordSelected = new EventEmitter<KeywordLookupItem | null>();

  constructor(private readonly lookupService: LookupService) {
    super();
  }

  override search(query: string): Observable<ListResult<KeywordLookupItem>> {
    return this.lookupService.getKeywords(undefined, query, this.writableOnly, this.lookupOnly, this.linkableOnly, this.includeDetails, this.audience, this.formId, 20);
  }

  override load(keys: string[]): Observable<ListResult<KeywordLookupItem>> {
    return this.lookupService.getKeywords(keys, undefined, this.writableOnly, this.lookupOnly, this.linkableOnly, this.includeDetails, this.audience, this.formId)
      .pipe(
        tap(result => this.KeywordsLoaded.emit({ keywords: result.items }))
      );
  }

  //Shirley Add 2025-09-30
  override handleChange(selected: KeywordLookupItem[] | KeywordLookupItem | null) {
    super.handleChange(selected);

    // 发射选中的 keyword 信息
    if (Array.isArray(selected)) {
      this.keywordSelected.emit(selected.length > 0 ? selected[0] : null);
    } else {
      this.keywordSelected.emit(selected);
    }
  }


}
